import styles from "./audioStyles.module.scss";
import { motion } from "framer-motion";
import AudioIcon from "../AudioIcon";
import { AudioComponent } from "@educaplay/core";
import { useState } from "react";
import { useEffect } from "react";

export default function AudioCard(props) {
  const { data, icon = true } = props;

  const [isPlaying, setPlaying] = useState(false);

  useEffect(() => {
    setPlaying(data.active);
  }, [data.active]);

  return (
    <motion.div
      className={styles.audioContainer}
      transition={{ duration: 0.3 }}
    >
      <div className={styles.audioCorner}>
        <AudioComponent
          className={styles.player}
          color={"var(--fillPlayer)"}
          source={data.src}
          autoplay={isPlaying}
        />
      </div>
      {icon && <AudioIcon className={styles.audioContent} />}
    </motion.div>
  );
}
